import React from 'react'
import PropTypes from 'prop-types'
import { Card } from 'components'
import { Spinner } from 'controls'

import { getErrorConfig } from './config'

import ListErrors from './ErrorFeeback'

const GeneralFeedback = ({
  error,
  success,
  loading,
  children,
  cardProps = {},
  errors = {},
  showErrors = false,
  messageSuccess = 'Operación realizada con éxito.',
  messageError = 'Lo sentimos, algo salió mal. Intente más tarde.'
}) => {
  if (loading) {
    return (
      <Card rounded bordered {...cardProps}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Spinner size={25} thickness={4} />
        </div>
      </Card>
    )
  }
  if (success) {
    return (
      <Card success bordered rounded {...cardProps}>
        {children || messageSuccess}
      </Card>
    )
  }

  if (error) {
    const errorResponseStatus = errors && errors.errorResponseStatus
    const configError = getErrorConfig(errorResponseStatus)

    return (
      <Card error bordered rounded {...cardProps}>
        {children || configError.message || messageError}

        <br />

        {configError.showErrorsFromResponse && (
          <ListErrors errors={errors || {}} />
        )}
      </Card>
    )
  }
  return null
}

GeneralFeedback.propTypes = {
  error: PropTypes.bool,
  success: PropTypes.bool,
  loading: PropTypes.bool,
  children: PropTypes.any,
  messageError: PropTypes.any,
  messageSuccess: PropTypes.any,
  cardProps: PropTypes.object
}

export default GeneralFeedback
